export default __webpack_public_path__ + "static/media/manutencao.d9c7d43a.jpg";